import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { permissionAbility } from "@/helpers/helpers";
import axios from "@/helpers/axios";
import allAdminRoutes from "./modules";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...allAdminRoutes,
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-403",
      name: "error-403",
      component: () => import("@/views/error/Error403.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

// global auth guard
router.beforeEach(async (to, from, next) => {
  // dynamic title
  window.document.title =
    to.meta && to.meta?.pageTitle
      ? `${process.env.VUE_APP_TITLE} | ${to.meta?.pageTitle}`
      : `${process.env.VUE_APP_TITLE}`;

  const isAuthenticated = store.getters["authModule/getIsAuthenticated"];
  const user = store.getters["userModule/getUser"];

  if (to.meta.requiresSuperAuth && user?.super_admin === 1) {
    next();
    return;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      try {
        // get user  permission
        const resUser = await axios.post(
          "/api/user?include=permissions,designation,roles,department",
        );

        const { permissions, ...user } = resUser?.data?.data;
        const mapPermissions = permissions?.data.map((item) => item.name);
        await store.dispatch("userModule/setUser", {
          user,
        });

        await store.dispatch("userModule/setPermissions", {
          permissions: mapPermissions,
        });

        // permission page
        const permissionsList = store.getters["userModule/getPermissions"];
        if (
          !to.meta?.gate ||
          permissionAbility(to.meta.gate, permissionsList)
        ) {
          next();
        } else {
          next("/error-403");
        }
      } catch (error) {
        await store.dispatch("authModule/setIsAuthenticated", {
          isAuthenticated: false,
          token: null,
          refreshToken: null,
        });

        await store.dispatch("authModule/clearPersistedState");

        await store.dispatch("userModule/removeUser");

        await store.dispatch("userModule/setPermissions", {
          permissions: null,
        });

        window.location.href = "/";
      }
    } else {
      next({ name: "login" });
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    if (isAuthenticated) {
      next({ name: "auth-dashboard" });
    } else {
      next();
    }
  } else {
    next();
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
